import React from 'react';
import Spinner from 'view/components/Spinner';

const SmsOutboundStatistics = ({
	statistics,
	isLoading,
	statsDays,
	onDaysChange,
	onRefresh,
}) => {
	if (isLoading) {
		return (
			<div className="card mb-4">
				<div className="card-body text-center py-5">
					<Spinner />
					<p className="text-muted mt-3">Loading outbound statistics...</p>
				</div>
			</div>
		);
	}

	if (!statistics?.stats) {
		return null;
	}

	const { stats } = statistics;

	return (
		<div className="sms-outbound-statistics mb-4">
			<div className="d-flex justify-content-end mb-2">
				<select
					className="form-select form-select-sm"
					style={{ width: 'auto' }}
					value={statsDays}
					onChange={(e) => onDaysChange(parseInt(e.target.value, 10))}
				>
					<option value={1}>Last 24 hours</option>
					<option value={7}>Last 7 days</option>
					<option value={30}>Last 30 days</option>
					<option value={90}>Last 90 days</option>
				</select>
				<button
					className="btn btn-sm btn-outline-secondary ms-2"
					onClick={onRefresh}
					title="Refresh Statistics"
				>
					<i className="bi bi-arrow-clockwise" />
				</button>
			</div>
			<div className="row g-3">
				<div className="col-md">
					<div className="card stat-card">
						<div className="card-body">
							<p className="text-muted mb-1">Total Outbound</p>
							<h3 className="mb-0">{(stats.total || 0).toLocaleString()}</h3>
						</div>
					</div>
				</div>
				<div className="col-md">
					<div className="card stat-card">
						<div className="card-body">
							<p className="text-muted mb-1">SMS Sent</p>
							<h3 className="mb-0 text-success">
								{(stats.sent || 0).toLocaleString()}
							</h3>
						</div>
					</div>
				</div>
				<div className="col-md">
					<div className="card stat-card">
						<div className="card-body">
							<p className="text-muted mb-1">SMS Digest</p>
							<h3 className="mb-0 text-info">
								{(stats.sent_digest || 0).toLocaleString()}
							</h3>
						</div>
					</div>
				</div>
				<div className="col-md">
					<div className="card stat-card">
						<div className="card-body">
							<p className="text-muted mb-1">SMS Failed</p>
							<h3 className="mb-0 text-danger">
								{(stats.failed || 0).toLocaleString()}
							</h3>
						</div>
					</div>
				</div>
				<div className="col-md">
					<div className="card stat-card">
						<div className="card-body">
							<p className="text-muted mb-1">SMS Pending</p>
							<h3 className="mb-0 text-warning">
								{(stats.pending || 0).toLocaleString()}
							</h3>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SmsOutboundStatistics;
